export const nl = {
  Name: "Naam",
  Firstnames: "Voornamen",
  Birthplace: "Geboorteplaats",
  Municipality: "Gemeente",
  Unknown: "Onbekend",
  "Date of birth": "Geboortedatum",
  "Living in": "WonendeTe",
  "Marital status": "BurgelijkeStaat",
  "Back to homepage": "Terug naar home",
  "Link to github repository": "Link naar github repository",
  "Link to github contributors page": "Link naar github bijdragers pagina",
  "Link to conduction website": "Link naar conduction website",
  "Opens a new window": "Opent een nieuw venster",
  "Phone number": "Telefoonnummer",
  "Email address": "E-mailadres",
  "Scroll table to the left": "Scroll tabel naar links",
  "Scroll table to the right": "Scroll tabel naar rechts",
  "The JWT validation failed with error message": "De JWT validation is misslukt met de foutmelding",
  "The JWT validation was successful": "De JWT validation is gelukt",
};
